import packageJson from "../package.json";

export const APP_NAME = packageJson.name;
// Cookie name
export const AUTH_COOKIE = `${APP_NAME}_authenticated`;

// Base public URL
export const PUBLIC_URL = process.env.PUBLIC_URL;

// App logo path
export const APP_LOGO = `${PUBLIC_URL}/img/logo_gwel.png`;
